/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnsureMedicaidCaseRequest
 */
export interface EnsureMedicaidCaseRequest {
    /**
     * 
     */
    owner_user_id?: string;
}

/**
 * Check if a given object implements the EnsureMedicaidCaseRequest interface.
 */
export function instanceOfEnsureMedicaidCaseRequest(value: object): value is EnsureMedicaidCaseRequest {
    return true;
}

export function EnsureMedicaidCaseRequestFromJSON(json: any): EnsureMedicaidCaseRequest {
    return EnsureMedicaidCaseRequestFromJSONTyped(json, false);
}

export function EnsureMedicaidCaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnsureMedicaidCaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner_user_id': json['owner_user_id'] == null ? undefined : json['owner_user_id'],
    };
}

export function EnsureMedicaidCaseRequestToJSON(json: any): EnsureMedicaidCaseRequest {
    return EnsureMedicaidCaseRequestToJSONTyped(json, false);
}

export function EnsureMedicaidCaseRequestToJSONTyped(value?: EnsureMedicaidCaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['owner_user_id'],
    };
}

